export default "__VITE_ASSET__CiSyBsmS__"